import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class PaisesServices {
  getPaises = params =>
    AxiosClient.get("/api/app/seleccion_contratacion_pais/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getPais = id =>
    AxiosClient.get(`/api/app/seleccion_contratacion_pais/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  savePaises = data =>
    AxiosClient.post("/api/app/seleccion_contratacion_pais/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editPaises = (id, data) =>
    AxiosClient.put(
      `/api/app/seleccion_contratacion_pais/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deletePais = id =>
    AxiosClient.delete(`/api/app/seleccion_contratacion_pais/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new PaisesServices();